module.exports = __webpack_public_path__ + "img/hill36.56abb2f0.jpg";